import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { ECategoryFile, ICategory } from '@features/categories/typescript';
import styles from '@features/categories/components/CategoriesChildren/CategoriesChildren.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import { RESPONSIVE_IMAGE_TYPES } from '@const/index';
import { BASE_PATH } from '@config/index';
import getImageQuality from '@utils/getImageQuality';
type PropsType = {
  categoryChildren: Record<symbol, ICategory>;
};
const CategoriesChildren = ({
  categoryChildren
}: PropsType) => {
  const {
    query,
    pathname
  } = useRouter();
  const createChildrenLinks = () => {
    const arr: {
      href: {
        pathname: string;
        query: {
          mainCategory: string;
          slug: string[];
        };
      };
      name: string;
      id;
    }[] = [];
    if (!categoryChildren) return arr;
    const childrenArray = Object.keys(categoryChildren);
    childrenArray.sort((a, b) => categoryChildren[a].position - categoryChildren[b].position);
    childrenArray.forEach(childId => {
      const {
        name,
        slug: childSlug,
        id
      } = categoryChildren[childId];
      const {
        mainCategory
      } = query;
      if (typeof mainCategory === 'string' && !categoryChildren[childId].hide_from_listing_thumbnail) {
        arr.push({
          href: {
            pathname,
            query: {
              mainCategory,
              slug: childSlug
            }
          },
          name,
          id
        });
      }
    });
    return arr;
  };
  const childrenLinks = useMemo(createChildrenLinks, [query, createChildrenLinks]);
  const renderThumbnail = childCategory => {
    let imageSrc = `${BASE_PATH}/img/no_image.svg`;
    const getImage = src => <Image src={src} width={80} height={80} loading="eager" quality={getImageQuality()} alt="" style={{
      objectFit: 'contain'
    }} />;
    if (categoryChildren[childCategory.id] === undefined) return getImage(imageSrc);
    const {
      files
    } = categoryChildren[childCategory.id];
    if (!files || !files?.length) return getImage(imageSrc);
    files.forEach(file => {
      const imageExists = file.type === ECategoryFile.thumbnailImage;
      const foundKey = Object.keys(file).find(key => RESPONSIVE_IMAGE_TYPES.includes(key) && !!file[key]);
      if (!imageExists || !foundKey) return;
      imageSrc = file[foundKey];
    });
    return getImage(imageSrc);
  };
  return <ErrorBoundary>
      <div sx={styles.voxContainer}>
        <div sx={styles.mainContainer}>
          {childrenLinks.map(child => {
          const {
            name,
            id,
            href
          } = child;
          return <Link key={`child${id}`} href={href} sx={styles.groupLink} className="category_thumbnail">
                <div sx={styles.groupThumbnailContainer}>{renderThumbnail(child)}</div>
                <span sx={styles.groupName}>{name}</span>
              </Link>;
        })}
        </div>
      </div>
    </ErrorBoundary>;
};
export default CategoriesChildren;